/**
 * Two-Categorical CSK Demo — application shell.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import { createMonographRouteApp } from "../MonographRouteApp.js";
import { NAVIGATION } from "./data/nav.js";
import { panelTokens } from "@csk/demo-ui";

export const App = createMonographRouteApp({
  navigation: NAVIGATION,
  theme: panelTokens,
  surfaceTokenPrefix: "tcc",
  slug: "two-categorical-csk",
  title: "Two-Categorical · Graded Bridges",
  eyebrow: "INTERACTIVE COMPANION · v0.1",
  tagline:
    "Typed bridges as the refusal of confused-deputy attacks at the SDP adjunction grade.",
  companionPath: "theory/manuscripts/contrib/TwoCategoricalCSK/",
  mainRegionId: "twocat-main",
  appLabel: "TWO-CATEGORICAL CSK",
  shortcutsTitle: "Two-Categorical CSK shortcuts",
  shortcutsDescription:
    "Keyboard commands for moving across the Two-Categorical CSK companion demo.",
  backgroundColor: "#0a1530",
});
